import React from 'react';

interface IconStepProfileProps {
  className?: string;
  size?: number;
}

export const IconStepProfile: React.FC<IconStepProfileProps> = ({ className = '', size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="#24A029"
      />
      <g clipPath="url(#clip0_step_profile)">
        <path
          d="M20 25.0013V14.168"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.5 20.8333C21.779 20.6226 21.1457 20.1839 20.695 19.5829C20.2443 18.982 20.0005 18.2512 20 17.5C19.9995 18.2512 19.7557 18.982 19.305 19.5829C18.8543 20.1839 18.221 20.6226 17.5 20.8333"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.665 15.4181C24.8568 15.086 24.9695 14.7142 24.9946 14.3316C25.0197 13.9489 24.9565 13.5656 24.8097 13.2113C24.663 12.857 24.4367 12.5412 24.1484 12.2884C23.8601 12.0355 23.5175 11.8524 23.1471 11.7532C22.7766 11.6539 22.3884 11.6412 22.0123 11.716C21.6361 11.7908 21.2823 11.9512 20.9781 12.1846C20.6738 12.4181 20.4274 12.7184 20.2578 13.0623C20.0882 13.4063 20 13.7846 20 14.1681C20 13.7846 19.9118 13.4063 19.7422 13.0623C19.5726 12.7184 19.3262 12.4181 19.0219 12.1846C18.7177 11.9512 18.3639 11.7908 17.9877 11.716C17.6116 11.6412 17.2234 11.6539 16.8529 11.7532C16.4825 11.8524 16.1399 12.0355 15.8516 12.2884C15.5633 12.5412 15.337 12.857 15.1903 13.2113C15.0435 13.5656 14.9803 13.9489 15.0054 14.3316C15.0305 14.7142 15.1432 15.086 15.335 15.4181"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.9976 14.2695C25.4874 14.3955 25.9421 14.6312 26.3274 14.959C26.7126 15.2867 27.0182 15.6978 27.221 16.1611C27.4239 16.6244 27.5186 17.1278 27.4981 17.6331C27.4775 18.1385 27.3423 18.6325 27.1026 19.0779"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25 25.0012C25.7338 25.0012 26.447 24.7591 27.0291 24.3124C27.6112 23.8657 28.0297 23.2394 28.2196 22.5307C28.4095 21.8219 28.3603 21.0703 28.0795 20.3924C27.7987 19.7145 27.3021 19.1482 26.6667 18.7812"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.6391 24.5703C26.6975 25.0222 26.6626 25.4812 26.5367 25.9191C26.4107 26.3569 26.1963 26.7643 25.9068 27.1161C25.6172 27.4679 25.2586 27.7565 24.8531 27.9643C24.4476 28.172 24.0038 28.2944 23.5491 28.3239C23.0944 28.3534 22.6385 28.2894 22.2096 28.1358C21.7806 27.9822 21.3877 27.7423 21.0551 27.4309C20.7225 27.1196 20.4573 26.7433 20.2758 26.3254C20.0943 25.9075 20.0004 25.4568 19.9999 25.0011C19.9994 25.4568 19.9055 25.9075 19.7241 26.3254C19.5426 26.7433 19.2773 27.1196 18.9447 27.4309C18.6121 27.7423 18.2192 27.9822 17.7902 28.1358C17.3613 28.2894 16.9054 28.3534 16.4507 28.3239C15.9961 28.2944 15.5523 28.172 15.1468 27.9643C14.7413 27.7565 14.3826 27.4679 14.0931 27.1161C13.8035 26.7643 13.5891 26.3569 13.4632 25.9191C13.3372 25.4812 13.3023 25.0222 13.3608 24.5703"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9999 25.0012C14.2662 25.0012 13.5529 24.7591 12.9708 24.3124C12.3887 23.8657 11.9702 23.2394 11.7803 22.5307C11.5904 21.8219 11.6397 21.0703 11.9204 20.3924C12.2012 19.7145 12.6978 19.1482 13.3333 18.7812"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0025 14.2695C14.5127 14.3955 14.0579 14.6312 13.6727 14.959C13.2875 15.2867 12.9819 15.6978 12.7791 16.1611C12.5762 16.6244 12.4815 17.1278 12.502 17.6331C12.5225 18.1385 12.6578 18.6325 12.8975 19.0779"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_step_profile">
          <rect width="20" height="20" fill="white" transform="translate(10 10)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconStepProfile;
